import React, { useState, useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { ImageUp } from "lucide-react";

const CustomFileUploader = ({ key, classes, handleChange, name, types }) => {
  const { t: translate, i18n } = useTranslation();

  const [errorMessage, setErrorMessage] = useState("");

  const generateContent = (errorMessage = "", errorClassName = "") => (
    <div
      className={clsx(
        `flex items-center justify-between cursor-pointer gap-1 border-dotted border-2 border-primary-300 rounded-md p-3 px-4`,
        errorMessage && "text-red-600"
      )}
    >
      <div className="flex items-center gap-1">
        <div className="flex items-center text-sm">
          <ImageUp className="mr-2 text-primary-600" />
          {errorMessage ? (
            <div className={`text-xs ${errorClassName}`}>{errorMessage}</div>
          ) : (
            <p className="text-primary-500">
              {translate("file-uploader.drag-message")}
            </p>
          )}
        </div>
        {!errorMessage && (
          <p className="text-gray-500 text-xs">
            {translate("file-uploader.browse-message")}
          </p>
        )}
      </div>
      <div className="text-xs dark:text-white">{types.join(", ")}</div>
    </div>
  );

  useEffect(() => {
    setCurrentState(generateContent(errorMessage));
  }, [errorMessage]);

  const [currentState, setCurrentState] = useState(generateContent);
  return (
    <FileUploader
      key={key}
      classes={classes}
      handleChange={handleChange}
      name={name}
      types={types}
      onTypeError={(err) => {
        setErrorMessage("Wrong File Type. Please choose another file");
      }}
      onSizeError={(err) => {
        setErrorMessage("File Size too Big. Please choose another file");
      }}
    >
      {currentState}
    </FileUploader>
  );
};

export default CustomFileUploader;
